import { Button } from "@mantine/core";
import { memo, useState } from "react";
import { ResetPasswordModalMemo } from "src/component/element/ResetPasswordModal";

interface ResetPasswordButtonProps {
  userId: string;
  userName?: string;
  userEmail?: string;
  userRole?: string;
  userNickname?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  variant?: "filled" | "light" | "outline" | "subtle" | "default" | "gradient";
  color?: string;
  onSuccess?: () => void;
}

const ResetPasswordButton = ({
  userId,
  userName,
  userEmail,
  userRole,
  userNickname,
  size = "xs",
  variant = "subtle",
  color = "blue",
  onSuccess,
}: ResetPasswordButtonProps) => {
  const [resetModalOpened, setResetModalOpened] = useState(false);

  return (
    <>
      <ResetPasswordModalMemo
        opened={resetModalOpened}
        onClose={() => setResetModalOpened(false)}
        userId={userId}
        userName={userName}
        userEmail={userEmail}
        userRole={userRole}
        userNickname={userNickname}
        onSuccess={onSuccess}
      />

      <Button
        size={size}
        variant={variant}
        color={color}
        sx={{ padding: 0 }}
        onClick={() => setResetModalOpened(true)}
      >
        パスワードリセット
      </Button>
    </>
  );
};

export const ResetPasswordButtonMemo = memo(ResetPasswordButton);
